function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLangEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 66.76 33.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(16.87 0.18)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "_Clipping_Path_",
    "data-name": "<Clipping Path>",
    cx: 16.51,
    cy: 16.51,
    r: 16.51,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_6",
    "data-name": "Ebene 6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "United_Kingdom",
    "data-name": "United Kingdom"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "British_Flag",
    "data-name": "British Flag"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.76,
    height: 33.38,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.76 29.65 66.76 22.25 51.97 22.25 66.76 29.65",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "38.94 23.2 38.94 33.38 59.3 33.38 38.94 23.2",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "7.46 33.38 27.82 33.38 27.82 23.2 7.46 33.38",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.79 22.25 0 22.25 0 29.65 14.79 22.25",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.97 11.13 66.76 11.13 66.76 3.73 51.97 11.13",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.3 0 38.94 0 38.94 10.18 59.3 0",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.82 10.18 27.82 0 7.46 0 27.82 10.18",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 3.73 0 11.13 14.79 11.13 0 3.73",
    style: {
      fill: "#253570"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.76 13.35 36.72 13.35 36.72 0 30.04 0 30.04 13.35 0 13.35 0 20.03 30.04 20.03 30.04 33.38 36.72 33.38 36.72 20.03 66.76 20.03 66.76 13.35",
    style: {
      fill: "#d70f28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "49.48 22.25 44.51 22.25 66.76 33.38 66.76 30.89 49.48 22.25",
    style: {
      fill: "#d70f28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.25 22.25 0 33.38 4.97 33.38 27.23 22.25 22.25 22.25",
    style: {
      fill: "#d70f28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.51 11.13 66.76 0 61.78 0 39.53 11.13 44.51 11.13",
    style: {
      fill: "#d70f28"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.28 11.13 22.25 11.13 0 0 0 2.49 17.28 11.13",
    style: {
      fill: "#d70f28"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEn);
export default __webpack_public_path__ + "static/media/lang_en.7085de0326ec7cbeb16f07d4c6f6a1dd.svg";
export { ForwardRef as ReactComponent };